export const MIGRATION_PHASE = {
  ASSES_BUSINESS_CASE: "Assess Business Case Phase",
  MOBILIZE: "Mobilize Phase",
  ASSESS: "Assess",
  MIGRATE_MODERNIZE: "Migrate and Modernize Phase",
  //TODO: This value may need to change...
  MOBILIZE_MIGRATE: "Mobilize Phase",
};
